import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    httpClient: any;
    private dealerLocationsCache$: Observable<Object> | null = null;
    private dealerLocationsCacheAt = 0;
    private alertAssigneesCache$: Observable<Object> | null = null;
    private alertAssigneesCacheAt = 0;
    private readonly lookupCacheTtlMs = 5 * 60 * 1000;

    constructor(private http: HttpClient) {}

    // Get Alert List
    getAlerts(filters?) {
        let params = new HttpParams();
        
        if(filters) {
            if (filters.read !== undefined && filters.read !== null) {
                params = params.set('read', filters.read);
            }
            if (filters.page !== undefined && filters.page !== null) {
                params = params.set('page', filters.page);
            }
            const locationId = filters.location_id || filters.dealer_location_id;
            if (locationId && locationId !== 'all') {
                params = params.set('location_id', locationId);
            }
            const assigneeId = filters.assignee_id || filters.user_id;
            if (assigneeId && assigneeId !== 'all') {
                params = params.set('assignee_id', assigneeId);
            }
            if (filters.missed_calls !== undefined && filters.missed_calls !== null) {
                params = params.set('missed_calls', filters.missed_calls);
            }
            const alertType = filters.alert_type || filters.unread_type;
            if (alertType && alertType !== 'all') {
                params = params.set('alert_type', alertType);
                if (alertType === 'missed_calls') {
                    params = params.set('missed_calls', 1);
                }
            }
        } else {
            params = params.set('read', 0);
        }
        
        return this.http.get<Array<Object>>(
            `${environment.api_url}/alerts`, {
                params: params
            }
        );
    }

    getDealerLocations() {
        const now = Date.now();
        if (!this.dealerLocationsCache$ || now - this.dealerLocationsCacheAt > this.lookupCacheTtlMs) {
            this.dealerLocationsCacheAt = now;
            this.dealerLocationsCache$ = this.http
                .get<Object>(`${environment.api_url}/dealer/locations`)
                .pipe(shareReplay({ bufferSize: 1, refCount: false }));
        }

        return this.dealerLocationsCache$;
    }

    getAlertAssignees() {
        const now = Date.now();
        if (!this.alertAssigneesCache$ || now - this.alertAssigneesCacheAt > this.lookupCacheTtlMs) {
            this.alertAssigneesCacheAt = now;
            this.alertAssigneesCache$ = this.http
                .get<Object>(`${environment.api_url}/alerts/assignees`)
                .pipe(shareReplay({ bufferSize: 1, refCount: false }));
        }

        return this.alertAssigneesCache$;
    }

    markAlertsRead(filters?) {
        return this.http.post<Object>(
            `${environment.api_url}/alerts/read`,
            filters || {}
        );
    }

    // Set Alert Status
    setAlertStatus(id) {
        return this.http.post<Object>(
            `${environment.api_url}/alert/${id}/read`, {}
        );
    }
    updateConversationTimestamp(id:number){
        return this.http.post<Object>(`${environment.api_url}/conversation/update_timestamp/${id}`, {});
    }
}
